import React from "react";
import { useState } from "react";
import { leaf, leaf2, mainLeaf } from "../assets";
import { TbLocationFilled } from "react-icons/tb";

const Locations = () => {
  const [branch, setBrance] = useState(
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.779814158976!2d90.40059267610714!3d23.790853887220624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c70ded40cdd3%3A0xa7d973e48d73df6f!2sLaser%20Treat%20Banani%20Branch!5e0!3m2!1sen!2sbd!4v1694537107147!5m2!1sen!2sbd"
  );
  const [activeBtn1, setActiveBtn1] = useState(true);
  const [activeBtn2, setActiveBtn2] = useState(false);
  const [activeBtn3, setActiveBtn3] = useState(false);

  const bananiBranch = () => {
    setBrance(
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.779814158976!2d90.40059267610714!3d23.790853887220624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c70ded40cdd3%3A0xa7d973e48d73df6f!2sLaser%20Treat%20Banani%20Branch!5e0!3m2!1sen!2sbd!4v1694537107147!5m2!1sen!2sbd"
    );

    setActiveBtn1(true);
    setActiveBtn2(false);
    setActiveBtn3(false);
  };

  const gulshanBranch = () => {
    setBrance(
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.5336446880033!2d90.41166007610735!3d23.799615686883644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c78e4e42ce77%3A0x6d6752754a0ef7ec!2sLaser%20Treat%20Gulshan%20Premium%20Branch!5e0!3m2!1sen!2sbd!4v1694537258813!5m2!1sen!2sbd"
    );

    setActiveBtn2(true);
    setActiveBtn1(false);
    setActiveBtn3(false);
  };

  const uttaraBranch = () => {
    setBrance(
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3648.5075198711706!2d90.38853807610873!3d23.871615584110526!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c4170e900cfd%3A0xeebb1c1fb24a4a06!2sLaser%20Treat%20Uttara%20Branch!5e0!3m2!1sen!2sbd!4v1694544335916!5m2!1sen!2sbd"
    );

    setActiveBtn3(true);
    setActiveBtn1(false);
    setActiveBtn2(false);
  };

  return (
    <div id="locations">
      <div className="gradient"></div>
      <img src={leaf2} className="mainLeaf" alt="" />
      <img src={mainLeaf} className="mainLeaf2" alt="" />

      <div className="top">
        <div className="left">
          <img src={leaf} alt="" />
          <h1>Our Locations</h1>
          <p>
            Visit our clinic for top-notch care in a comfortable setting. Expert
            team, accessible location. Your health, our priority.
          </p>
          <div className="btn-grp">
            <button
              className={activeBtn1 ? "active" : ""}
              onClick={() => bananiBranch()}
            >
              <TbLocationFilled className="ico" />
              Banani
            </button>
            <button
              className={activeBtn2 ? "active" : ""}
              onClick={() => gulshanBranch()}
            >
              <TbLocationFilled className="ico" />
              Gulshan
            </button>
            <button
              className={activeBtn3 ? "active" : ""}
              onClick={() => uttaraBranch()}
            >
              <TbLocationFilled className="ico" />
              Uttara
            </button>
          </div>
        </div>

        <iframe
          src={branch}
          title="branch"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      <div className="bottom">
        <div className="address">
          <img src={leaf} alt="" />
          <h2>Banani 11</h2>

          <ul>
            <li>
              The Laureate, House: 56 (3rd Floor), Road: 11, Block: F, Banani,
              Dhaka-1213, Bangladesh.
            </li>
            <li>Opening Hours: Everyday 10.00 AM to 08.00 PM</li>
            <li>Helpline: +88 017 500 100 20, +88 017 500 100 30</li>
          </ul>
        </div>
        <div className="address">
          <img src={leaf} alt="" />
          <h2>Gulshan</h2>

          <ul>
            <li>
              House: 4/A (2nd Floor), Road: 84, Gulshan 2, Dhaka 1212,
              Bangladesh.
            </li>
            <li>Opening Hours: Everyday 10.00 AM to 08.00 PM</li>
            <li>Helpline: +88 017 500 100 26,09 67 80 06 007</li>
          </ul>
        </div>
        <div className="address">
          <img src={leaf} alt="" />
          <h2>Uttara</h2>

          <ul>
            <li>
              Garibe Newaz Avenue, Plot No: 30 (4th Floor), Sector:13, Uttara,
              Dhaka-1230, Bangladesh.
            </li>
            <li>Opening Hours: Everyday 10.00 AM to 08.00 PM</li>
            <li>Helpline: +88 017 500 100 26, +88 017 500 100 28</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Locations;
